import { Injectable } from '@angular/core';
import { HttpService } from 'projects/customer/src/app/shared/services/http-service.service';
import { HttpClient } from '@angular/common/http';
import {
    Service,
    Resource,
    DocumentCollection,
    DocumentResource
} from 'ngx-jsonapi';
import { AxiosAuthenticationService } from 'projects/customer/src/app/shared/services/axios-authentication.service';

@Injectable({ providedIn: 'root' })
export class Product extends Resource {
    public attributes = {
        type: '',
        id: ''
    };
    public relationships = {
        category: new DocumentResource<category>(),
        storage_type: new DocumentResource<storageType>(),
        product_stock: new DocumentResource<productStock>(),
        origin_country: new DocumentResource<originCountry>()
    };
}

@Injectable({ providedIn: 'root' })
export class category extends Resource {
    public attributes = {
        type: '',
        id: ''
    };
}
@Injectable({
    providedIn: 'root'
})
export class categoryservice extends AxiosAuthenticationService<category> {
    public resource = category;
    public type = 'category';
}

@Injectable({ providedIn: 'root' })
export class storageType extends Resource {
    public attributes = {
        type: '',
        id: ''
    };
}
@Injectable({
    providedIn: 'root'
})
export class storageTypeservice extends AxiosAuthenticationService<storageType> {
    public resource = storageType;
    public type = 'storage_type';
}

@Injectable({ providedIn: 'root' })
export class productStock extends Resource {
    public attributes = {
        type: '',
        id: ''
    };
}
@Injectable({
    providedIn: 'root'
})
export class productStockService extends AxiosAuthenticationService<productStock> {
    public resource = productStock;
    public type = 'product_stock';
}

@Injectable({ providedIn: 'root' })
export class originCountry extends Resource {
    public attributes = {
        type: '',
        id: ''
    };
}
@Injectable({
    providedIn: 'root'
})
export class origincountryService extends AxiosAuthenticationService<originCountry> {
    public resource = originCountry;
    public type = 'origin_country';
}

@Injectable({ providedIn: 'root' })
export class ProductAllService extends AxiosAuthenticationService<Product> {
    public resource = Product;
    public type = 'product';
}

@Injectable({ providedIn: 'root' })
export class BulkActivityService extends AxiosAuthenticationService<Product> {
    public resource = Product;
    public type = 'bulk_activity';
}

@Injectable({ providedIn: 'root' })
export class BulkActivitiesService extends AxiosAuthenticationService<Product> {
    public resource = Product;
    public type = 'bulk_activities';
}

@Injectable({
    providedIn: 'root'
})
export class ProductConfigurationService extends Service<Product> {
    constructor(private http: HttpClient, public httpService: HttpService) {
        super();
    }

    getProductData(id) {
        const path = `products/${id}/product_details`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    createProduct(data) {
        const path = 'products/create';
        return this.httpService.callAuthPostApi(path, data, 'jsonApi');
    }

    updateProduct(data, id) {
        const path = `products/${id}/update_product`;
        return this.httpService.callPutApi(path, data, 'jsonApi');
    }

    getInventoryCount() {
        const path = `products/counts`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getStoreTypes() {
        const path = 'products/storage_types';
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getCurrencyData() {
        const path = 'products/currency';
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getCountryList() {
        const path = 'v1/masters/countries';
        return this.httpService.callAuthGetMasterApi(path);
    }

    getProductTemplateFile() {
        const path = 'v1/masters/templates?type=16';
        return this.httpService.getFileAsBlob(path);
    }

    bulkUploadProductData(file) {
        const path = 'products/import_product_update';
        return this.httpService.callUploadFileServiceApi(path, file, 'jsonApi');
    }
    bulkExportProductData(params, ext) {
        const path =
            'products/export_product_update?product_ids=' +
            params +
            '&file_type=' +
            ext;
        return this.httpService.getFileAsBlob(path, 'jsonApi');
    }
    bulkExportProductAllData(params, ext) {
        const path = 'products/export_product_update?file_type=' + ext;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
    getGridData(path) {
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
}
